import { useMemo } from "react";
import { parseTextForTags } from "./texttokenhelpers";
export var useI18nTextWithTags = function (text) {
    return useMemo(function () {
        return parseTextForTags(text);
    }, [text]);
};
